import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, RateAllCandidaciesResponse } from "@/types";

export function useRateAllCandidacies() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/rate-all-candidacies`;
      const res = await guacHttpClient.post<
        RateAllCandidaciesResponse,
        HttpResponse<RateAllCandidaciesResponse>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
